/* eslint-disable no-console */
import z from "zod";

export const envVariablesSchema = z.object({
  EXPO_PUBLIC_ENVIRONMENT: z.enum([
    "local",
    "development",
    "staging",
    "production",
  ]),
  EXPO_PUBLIC_SENTRY_DSN: z.string().optional(),
  EXPO_PUBLIC_SERVER_URL: z.url(),
  EXPO_PUBLIC_FIREBASE_API_KEY: z.string(),
  EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN: z.string(),
  EXPO_PUBLIC_FIREBASE_PROJECT_ID: z.string(),
  EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: z.string(),
  EXPO_PUBLIC_FIREBASE_APP_ID: z.string(),
  EXPO_PUBLIC_FIREBASE_TENANT_ID: z.string(),
  EXPO_PUBLIC_FIREBASE_TENANT_ID_ADMINS: z.string(),
  EXPO_PUBLIC_PLACES_API_KEY: z.string(),
  EXPO_PUBLIC_MIXPANEL_TOKEN: z.string(),
  EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID: z.string(),
});

const parsed = envVariablesSchema.safeParse(process.env);

if (parsed.success === false) {
  console.error(
    "❌ Invalid environment variables:",
    parsed.error.issues,
    `\n❌ Ensure all required environment variables are set correctly in your .env.<ENVIRONMENT> file with the correct format.`,
  );

  throw new Error(
    "Invalid environment variables, Check terminal for more details ",
  );
}

export const envVariables = parsed.data;
